import axios from "axios";
import { commonAxios } from "../../Global/CommonAxios";
import { setAlert } from "./AlertActions";
import { baseURL } from "../../Global/Global";



export const FetchAdminTaskSearchUser = (url, formData, loader, setLoader, setData, setTotalLength, handleClose) => (dispatch, getState) => {

    commonAxios(url, formData, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {

                setData(res.data.userlist)
                setTotalLength(res.data.total_count)
                handleClose()

            } else {
                console.log(res.msg)

            }
            setLoader({
                ...loader,
                search: false,
            })
            handleClose()

        }).catch((err) => {
            console.log(err)

        })
}
export const FetchAdminTaskTaskerUser = (formData, loader, setLoader, setData, setSearchData) => (dispatch, getState) => {

    commonAxios("fetch-user-list", formData, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                setData(res.data)
                setSearchData({
                    "name": "",
                    "email": "",
                    "mobileNumber": "",
                })
            } else {
                console.log(res.msg)

            }
            setLoader({
                ...loader,
                fetch: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}
export const FetchAdminEmpolyeeUserlist = (url, formData, loader, setLoader, setData) => (dispatch, getState) => {

    commonAxios(url, formData, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                setData(res.data)

            } else {
                console.log(res.msg)

            }
            setLoader({
                ...loader,
                fetch: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}
export const deleteAdminEmpolyeeUserlist = (url, formData, loader, setLoader, handleClose, fetchData) => (dispatch, getState) => {

    commonAxios(url, formData, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                dispatch(setAlert(res.msg, "success"))
                handleClose()
                fetchData()

            } else {
                dispatch(setAlert(res.msg, "danger"))

            }
            handleClose()
            setLoader({
                ...loader,
                delete: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}
export const PaymentSettingAdminFetch = (url, setPayment, loader, setLoader,) => (dispatch, getState) => {
    commonAxios(url, {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {

                setPayment({ "payment": res.data.data[1].value, "transfer": res.data.data[0].value })
            }
            setLoader((prev) => ({
            ...prev,
            fetch: false,}))
        }).catch((err) => {
            console.log(err)

        })
}
export const withdrawPaymentSettingAdminFetch = (url, setWithdrawalAmount, loader, setLoader,) => (dispatch, getState) => {
    commonAxios(url, {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
            
                setWithdrawalAmount({ "amount": res.data[0].amount_limit })
            }
         setLoader((prev) => ({
            ...prev,
            withdrawal: false,}))
            // setLoader({
            //     ...loader,
            //     withdrawal: false,
            // })
        }).catch((err) => {
            console.log(err)

        })
}
export const updateWithdrawSettingAdmin = (url,data, loader, setLoader,) => (dispatch, getState) => {
    commonAxios(url, data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {

                dispatch(setAlert(res.msg, "success"))
            }
            else{
                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader({
                ...loader,
                update: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}
export const PaymentSettingAdminUpdate = (url, formData, loader, setLoader, handleClose, payment, setPayment) => (dispatch, getState) => {
    commonAxios(url, formData, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                dispatch(setAlert(res.msg, "success"))

                setPayment({ ...payment, [formData.type]: formData.status })


                if (handleClose) {
                    handleClose()
                }

            } else {
                dispatch(setAlert(res.msg, "danger"))
                const reversedStatus = formData.status === '1' ? '0' : formData.status === '0' ? '1' : formData.status
                setPayment({ ...payment, [formData.type]: reversedStatus });
                setPayment({ ...payment, [formData.type]: formData.status })
            }
            setLoader({
                ...loader,
                save: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}

export const FetchAdminTaskTaskerSubmissionlist = (formData, loader, setLoader, setData) => (dispatch, getState) => {

    commonAxios("fetch-task-submission-list", formData, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                setData(res.data)

            } else {
                console.log(res.msg)

            }
            setLoader({
                ...loader,
                fetch: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}
export const FetchAdminCreatorUser = (formData, loader, setLoader, setData) => (dispatch, getState) => {

    commonAxios("/fetch-creator-list", formData, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                setData(res.data)

            } else {
                console.log(res.msg)

            }
            setLoader({
                ...loader,
                fetch: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}


export const FetchAdminTaskerUserDetails = (data, loader, setLoader, setUserData) => (dispatch, getState) => {

    commonAxios("admin-users-details", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                setUserData(res.data)

            } else {
                console.log(res.msg)

            }
            setLoader({
                ...loader,
                fetch: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}
export const FetchAdminCreaterUserDetails = (data, loader, setLoader, setUserData) => (dispatch, getState) => {

    commonAxios("admin-creator-details", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                setUserData(res.data)

            } else {
                console.log(res.msg)

            }
            setLoader({
                ...loader,
                fetch: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}

export const activeAccountUserDetails = (data, loader, setLoader, handleClose1, fetchDataTasker) => (dispatch, getState) => {

    commonAxios("activate-account", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                dispatch(setAlert(res.msg, "success"))
                fetchDataTasker()

            } else {
                console.log(res.msg)
                dispatch(setAlert(res.msg, "danger"))
            }
            handleClose1()
            setLoader({
                ...loader,
                banAccount: false,
            })
        }).catch((err) => {
            console.log(err)

        })
}

export const banAccoutUserDetails = (data, loader, setLoader, handleClose, fetchDataTasker) => (dispatch, getState) => {

    commonAxios("ban-account", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                dispatch(setAlert(res.msg, "success"))
                fetchDataTasker()
            } else {
                console.log(res.msg)
                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader({
                ...loader,
                active: false,
            })
            handleClose()
        }).catch((err) => {
            console.log(err)

        })
}